import {
  APIClient,
  // CSRFMiddleware,
  ErrorMiddleware,
  JSONResultMiddleware,
} from './api'

export const apiClient = new APIClient(null, [
  new ErrorMiddleware(),
  // new CSRFMiddleware(),
  new JSONResultMiddleware(),
])



// WEBPACK FOOTER //
// ./src/shared/api-impl.js